export default new class WorkflowsAssistant {
  public isCloneable(workflowName: string): boolean {
    return !workflowName.endsWith('(copy)')
  }
}()
